import Vue from "vue";

/**
 * Class Profile Service
 */
export default class SquadService extends Vue {
    
    private customActions = {
        show: { method: 'GET', url: 'auth/commission/squad{/id_platform}' },
        store: { method: 'POST', url: 'auth/squad/platform{/id_platform}' },
        update: { method: 'PUT', url: 'auth/squad/platform{/id_platform}' },
        showSquad: { method: 'GET', url: 'auth/squad/platform{/id_platform}{/id_squad}' },
        statusList: { method: 'GET', url: 'auth/status/commission/squad' },
    };
    
    private resource: any = this.$resource('auth/commission/squad', {}, this.customActions);

    public async show(id_platform:string) {
        return await this.resource.show({ id_platform }).then(
            (response: any) => {
                return response.json();
            },
            (response: any) => {
                return response.json();
            }
        );
    }

    public async showSquad(id_platform: string, id_squad?: number) {
        return await this.resource.showSquad({ id_platform, id_squad }).then(
            (response: any) => {
                return response.json();
            },
            (response: any) => {
                return response.json();
            }
        );
    }

    public async store(id_platform: string, params: any) {
        return await this.resource.store({ id_platform }, params).then(
            (response: any) => {
                return response.json();
            },
            (response: any) => {
                return response.json();
            }
        );
    }

    public async update(id_platform: string, params: any) {
        return await this.resource.update({ id_platform }, params).then(
            (response: any) => {
                return response.json();
            },
            (response: any) => {
                return response.json();
            }
        );
    }

    public async statusList() {
        return await this.resource.statusList().then(
            (response: any) => {
                return response.json();
            },
            (response: any) => {
                return response.json();
            }
        );
    }
}